import React, { useEffect, useState } from "react";
import { Briefcase } from "lucide-react";
import { api } from "../../lib/api";

// Personal HR alerts (e.g. leave approved) for every signed-in user.
export function HrBell() {
  const [data, setData] = useState({ unread: 0, items: [] });
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let dead = false;
    const tick = () => api.get("/hr/notifications").then(({ data: d }) => !dead && setData(d)).catch(() => {});
    tick();
    const t = setInterval(() => !document.hidden && tick(), 60_000);
    return () => { dead = true; clearInterval(t); };
  }, []);
  const toggle = () => {
    setOpen((o) => !o);
    if (!open && data.unread) api.post("/hr/notifications/read").then(() => setData((d) => ({ ...d, unread: 0 }))).catch(() => {});
  };
  return (
    <div className="relative shrink-0">
      <button onClick={toggle} className="relative h-9 w-9 rounded-md inline-flex items-center justify-center hover:bg-violet-50 text-violet-600" title="HR alerts: leave, letters, attendance" data-testid="hr-bell-btn">
        <Briefcase className="h-4 w-4" />
        {data.unread > 0 && <span className="absolute -top-0.5 -right-0.5 h-4 min-w-[16px] px-1 rounded-full bg-violet-600 text-white text-[10px] font-bold flex items-center justify-center" data-testid="hr-bell-badge">{data.unread}</span>}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-80 max-w-[calc(100vw-1rem)] z-50 bg-white rounded-xl border border-slate-200 shadow-2xl overflow-hidden" data-testid="hr-bell-panel">
            <div className="px-3 py-2 text-[10px] uppercase tracking-wider font-bold text-slate-500 bg-slate-50 border-b">HR alerts</div>
            <div className="max-h-80 overflow-y-auto divide-y divide-slate-100">
              {data.items.length === 0 ? <div className="p-6 text-center text-sm text-slate-500">No alerts yet.</div> : data.items.map((n) => (
                <div key={n.id} className={`px-3 py-2.5 ${n.read ? "" : "bg-violet-50/60"}`}><div className="text-sm font-semibold text-slate-900">{n.title}</div><div className="text-xs text-slate-600">{n.body}</div>
                  <div className="text-[10px] text-slate-400 mt-0.5">{new Date(n.created_at).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</div></div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
